module.exports = __webpack_public_path__ + "static/media/promo.fd73b2d0.png";